import { Row, Col, Form, Table } from "react-bootstrap";
import React, {
  useImperativeHandle,
  forwardRef,
  useState,
  useEffect,
  useRef,
} from "react";
import {
  isAlphanumericAllSpecialCharacters,
  isAlphanumericAllSpecialCharactersAmpersand,
  isAllowCustomSpecialCharacters,
  handleOnInput,
  SquareBracketNotAllowed,
  isAlphanumericSpecialCharactersRestricted,
  isAlphanumericSpecialCharactersRestrictedChar,
   isAlphanumericMinusPlusPercent,
   isAlphanumericMinusPlusPercentDiameter,
   isAlphanumericAllSpecialCharactersPlusMinusDegree,
   isAlphanumericAllSpecialCharactersPlusMinusDegreeWithAngleBrackets,
   isAlphanumericWithDiameterDashSlash,
   isAlphanumericWithDashSlashPlusAmpersand

} from "../../functions/validations";
import { division, Company_Name } from "./PQRObjects/PQR_entity";
import { FM_Product_Form, Welding_Standard } from "../utility/common/TransactionComponents/TransactionEntity";
import { Action, MessageTypes, Status } from "../utility/common/constants/CommonConstants";
import { validatePQRForm, validatePQRProcesses, validatePQRDuplicate } from "./PQRObjects/PQR_ValidationConfig";
import { getbyprojectno } from "../../Services/pqr-header-service";
import {
  AddNewDetail,
  DeletePQRProcess,
} from "../../Services/pqr-details-service";
import { getPNOActive } from "../../Services/pcategory-service";
import { getActiveProcess } from "../../Services/weldingprocess-services";
import {
  checkduplicateProcess,
  checkPQRProcessAdded,
  AddUpdatePQRHeader,
} from "./PQRObjects/PQR_Validations";
import {
  SingleInput,
  General_Single_Input_select,
} from "../utility/forms/inputs/InputsTransaction";
import {
  PQRProcessGridInput2,
  PQRProcessGridInput3,
  PQRFillerMetalInput,
  PQR_Process_Grid_Select,
} from "./PQRObjects/PQR_Process_Grid";
import { getPresignedURL } from "../../Services/Welder-services";
import { PQRProcess } from "./PQRObjects/PQRProcess";
import { DateInputUser } from "../utility/common/helpers/DateComponent";
import { BaseMetalTablePQR } from "./PQRObjects/BaseMetalTablePQR";
import axios from "axios";
import { getActiveSfa } from "../../Services/sfa-service";
import {
  ImageArray2,
  fetchImagePreview,
  validateFile,
} from "../utility/common/TransactionComponents/CommonImages";
import { getActiveFno } from "../../Services/fno-services";
import { getActiveAno } from "../../Services/ano-services";
import { createCommonFetchUtilities } from "../utility/common/TransactionComponents/TransactionValidationUtils";
import {
  handlePQRGeneralSubmit,
  handlePQRGeneralSubmitTemp,
  createPQRTestDataObjects,
} from "../utility/common/TransactionComponents/TransactionSubmitUtils";
import { todayDate } from "../utility/common/helpers/TodayDate";
import { DotLoader } from "react-spinners";
import { emptyError } from "./PQRObjects/PQR_common";

const PQRPage1 = forwardRef(
  (
    {
      headerObj,
      setheaderObj,
      detailObj,
      setdetailObj,
      errorstyle,
      blyestyle,
      WPStype,
      isDisabled,
      isReadonly,
      toast,
      prevdetailobj,
      setprevdetailObj,
      setaction,
      action,
      setIsDisabled,
    },
    ref,
  ) => {
    let folderPQR = "PQR_GrooveOverlay";

    console.log("setheaderObj in pqrpage1:: ", setheaderObj, headerObj)

    const [ProcessActive, setProcessActive] = useState([]);
    const [PNoActive, setPNoActive] = useState([]);
    const [SfaActive, setSfaActive] = useState([]);
    const [AnoActive, setAnoActive] = useState([]);
    const [FnoActive, setFnoActive] = useState([]);
    const [isEdited, setIsEdited] = useState(false);

    const [isoverlay] = useState(WPStype === "Groove" ? false : true);
    const [profile, setProfile] = useState("");
    const [profile1, setProfile1] = useState("");
    const [previewUrl1, setPreviewUrl1] = useState();
    const [previewUrl2, setPreviewUrl2] = useState();
    const [isChecked, setIsChecked] = useState(true);
    const [fieldPWHT, setFieldPWHT] = useState(false);
    const [ImageView1, setImageView1] = useState(false);
    const [ImageView2, setImageView2] = useState(false);
    const [loading, setLoading] = useState(false);

    const [error, setError] = useState({
      PQR_RecordNo: {},
      PQR_ReviNo: {},
      PQR_WPS_RecordNo: {},
      PQR_WPS_ReviNo: {},
      PQR_Date: {},
      PQR_CompanyName: {},

      PQR_PWHeatTre_Temperature: {},
      PQR_PWHeatTre_Time: {},
      PQR_PWHeatTre_Type: {},
      PQR_PWHeatTre_Heating_Rate: {},
      PQR_PWHeatTre_Heating_Method: {},

      PQR_PWHeatTre_Cooling_Rate: {},
      PQR_PWHeatTre_Cooling_Method: {},

      PQR_PWHeatTre_Notes: {},
      PQR_PWHeatTre_Maintenance: {},

      PQR_Wps_RecordNo: {},
      PQR_ReferenceCode: {},
      PQR_Inspection: {},
      PQR_DOB: {},
      PQR_Qualificationcode: {},
      PQR_Last_UpdatedDate: {},
      PQR_Last_UpdatedBy: {},
      PQR_Welded_on_coupon: {},
      PQR_Division: {},
      PQR_PlantLocation: {},
      PQR_WeldingStandard: {},
      PQR_specialNote: {},
      PQR_Status: {},

      PQR_BM_BM_ProductForm: {},
      PQR_BM_BM_Spec: {},
      PQR_BM_BM_Pno: {},
      PQR_BM_BM_Gno: {},
      PQR_BM_BM_Size: {},
      PQR_BM_BM_Sch: {},
      PQR_BM_BM_Thk: {},
      PQR_BM_BM_Dia: {},

      // PQR_BM_BM_Condition1: {},
      // PQR_BM_BM_Condition2: {},
      PQR_BM_HeatTreatmentCondition: {},
      PQR_BM_BM_Notes: {},

      PQR_BM_WTBM_ProductForm: {},
      PQR_BM_WTBM_Spec: {},
      PQR_BM_WTBM_Pno: {},
      PQR_BM_WTBM_Gno: {},
      PQR_BM_WTBM_Size: {},
      PQR_BM_WTBM_Sch: {},
      PQR_BM_WTBM_Thk: {},
      PQR_BM_WTBM_Dia: {},

      PQR_JD_JointDesign: {},
      PQR_JD_Backing: {},
      PQR_JD_Retainers: {},
      PQR_JD_GrooveAngle: {},
      PQR_JD_RootOpening: {},
      PQR_JD_RootFace: {},
      PQR_JD_Notes: {},

      PQR_JD_TubePitch: {},
      PQR_JD_TubeProj: {},
      PQR_JD_Pattern: {},

      PQRD_FM_SFA: {},
      PQRD_FM_Classification: {},
      PQRD_FM_FNo: {},
      PQRD_FM_Ano: {},
      PQRD_FM_Nominal: {},
      PQRD_FM_TradeName: {},

      PQRD_FM_ProductForm: {},
      PQRD_FM_FillerMetalSize: {},
      PQRD_FM_DepositedThickness: {},
      PQRD_FM_MaxPassThickness: {},
      PQRD_FM_WeldDepositChemistry: {},
      PQRD_FM_FluxAWS: {},
      PQRD_FM_FluxNominalComposition: {},
      PQRD_FM_FluxTradeName: {},
      PQRD_FM_FluxType: {},
      PQRD_FM_FluxRecrushed: {},
      PQRD_FM_Supplement: {},
      PQRD_FM_FillerMetalOthers: {},

      PQRD_Position_PositionofGroove: {},
      PQRD_Position_WeldProgression: {},

      PQRD_Preheat_MinimumPreheatTemp: {},
      PQRD_Preheat_MaximumInterpassTemp: {},

      PQRD_Gas_ShieldingType: {},
      PQRD_Gas_ShieldingFlowRate: {},
      PQRD_Gas_BackingType: {},
      PQRD_Gas_BackingFlowRate: {},
      PQRD_Gas_TrailingType: {},
      PQRD_Gas_TrailingFlowRate: {},

      PQRD_Electrical_FillerMetalSize: {},
      PQRD_Electrical_Amperes: {},
      PQRD_Electrical_Volts: {},
      PQRD_Electrical_TravelSpeed: {},
      PQRD_Electrical_minBeadLength: {},
      PQRD_Electrical_ArcTransferMode: {},
      PQRD_Electrical_MaxHeatInput: {},
      PQRD_Electrical_TungstenType: {},
      PQRD_Electrical_CurrentPolarity: {},
      PQRD_Electrical_DCPulsatingCurrent: {},
      PQRD_Electrical_Others: {},
      PQRD_Electrical_WireFeedType: {},
      PQRD_Electrical_WireFeedSpeed: {},
      PQRD_Technique_StringOrWeave: {},
      PQRD_Technique_Orifice_GasCupSize: {},
      PQRD_Technique_CTWD: {},
      PQRD_Technique_Oscillation: {},
      PQRD_Technique_Multi_SingleElectrode: {},
      PQRD_Technique_ElectrodeAngle: {},
      PQRD_Technique_SinglePassPerSide: {},
      PQRD_Technique_Multiple_SingleLayer: {},
      PQRD_Technique_Peening: {},
      PQRD_Technique_InitialInterpassCleaning: {},
      PQRD_Technique_BackGaugingMethod: {},
      PQRD_Technique_Technique_Other: {},
      PQRD_Technique_GroovePreparation: {},

      PQRD_Technique_ElectrodesSamePuddle: {},
      PQRD_Technique_SupplimentalDevice: {},
      PQRD_Technique_Overlaping: {},
      PQR_WP_Process_Process: {},
      PQR_WP_Process_Type: {},
      PQR_WP_Type_Process: {},
      PQR_WP_Type_Type: {},
      WPSH_Project_No: {},
      WPSH_WPS_No: {},
      WPSH_WPS_Revi_No: {},
      WPS_QualifiedTo: {},
      WPSH_SupportingPQR: {},
      WPSH_WPS_Date: {},
      WPSH_RefDoc: {},
      WPSH_Scope: {},
      WPSH_JointDesc: {},
      WPSH_BM_Type_Type: {},
      WPSH_BM_WeldingTo_Type: {},
      WPSH_BM_Type_GNo: {},
      WPSH_BM_Type_PNo: {},
      WPSH_BM_WeldingTo_PNo: {},
      WPSH_BM_WeldingTo_GNo: {},
      WPSH_BM_Backing_Backing: {},
      WPSH_BM_Backing_GNo: {},
      WPSH_BM_Backing_PNo: {},
      WPSH_BM_Retainer: {},
      WPSH_WPS_WeldLayer: {},
      WPSH_BM_Backing_Material: {},
      WPSH_ConsuInsert_SFA: {},
      WPSH_ConsuInsert_Classification: {},
      WPSH_ConsuInsert_FNo: {},
      WPSH_ConsuInsert_ANo: {},
      WPSH_ConsuInsert_ChemicalAnalysis_TradeName: {},
      WPSH_Flux_SFA: {},
      WPSH_Flux_Classification: {},
      WPSH_Flux_FNo: {},
      WPSH_Flux_ANo: {},
      WPSH_Flux_ChemicalAnalysis_TradeName: {},
      WPSH_SupFiller_SFA: {},
      WPSH_SupFiller_Classification: {},
      WPSH_SupFiller_FNo: {},
      WPSH_SupFiller_ANo: {},
      WPSH_SupFiller_ChemicalAnalysis_TradeName: {},
      WPSH_BM_Notes: {},
      WPSH_TRQ_GroovewithoutImpact_Min: {},
      WPSH_TRQ_GroovewithoutImpact_Max: {},
      WPSH_TRQ_GroovewithImpact_Min: {},
      WPSH_TRQ_GroovewithImpact_Max: {},
      WPSH_TRQ_FilletwithoutImpact_Min: {},
      WPSH_TRQ_FilletwithoutImpact_Max: {},
      WPSH_TRQ_FilletwithImpact_Min: {},
      WPSH_TRQ_FilletwithImpact_Max: {},
      WPSH_FM_FluxType: {},
      WPSH_FM_AlloyFlux: {},
      WPSH_FM_AlloyElement: {},
      WPSH_FM_Add_Del_Filler: {},
      WPSH_FM_Add_Del_Flux: {},
      WPSH_FM_Add_Del_orchange: {},
      WPSH_FM_FluxItemBatch: {},
      WPSH_FM_FluxFromRecrush: {},
      WPSH_FM_FluxItemCode: {},
      WPSH_FM_FilerMetal: {},
      WPSD_FM_Classification: {},
      WPSH_BM_Type_HT_Con: {},
      WPSH_BM_WeldingTo_HT_Con: {},
      WPSD_FM_ChemicalAnalysis_TradeName: {},
      WPSD_FM_TRQ_Min: {},
      WPSD_FM_TRQ_Max: {},
      WPSH_ConsuInsert: {},
      WPSD_FM_Make: {},
      WPSH_Flux: [],
      WPSH_SupFiller: [],
      WPSH_MinOvlFinThick: {},

      PQR_Process: {},
      WPSH_TRQ_BaseMetalCRO_Min: {},
      WPSH_TRQ_BaseMetalCRO_Max: {},
      WPSH_TRQ_BaseMetalHRO_Min: {},
      WPSH_TRQ_BaseMetalHRO_Max: {},
    });
    const handleChange = (e) => {
      setIsEdited(true);

      const { name, value } = e.target;
      setheaderObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };
    const handleChange3field = (row, col, key, e) => {
      setIsEdited(true);

      let onChangeVal = [...detailObj];
      
      // Initialize the array if it doesn't exist
      if (!onChangeVal[row][key]) {
        onChangeVal[row][key] = ["", "", ""];
      }
      
      onChangeVal[row][key][col] = e.target.value;
      setdetailObj(onChangeVal);
    };

    const handleChangedetailsarray = (e, i) => {
      setIsEdited(true);
      const { name, value } = e.target;
      const onChangeVal = [...detailObj];
      onChangeVal[i][name] = value;
      setdetailObj(onChangeVal);
      setError((prevState) => ({
        ...prevState,
        [name]: { status: false, message: "" },
      }));
    };

    const handleProcessCheckboxChange = (processIndex, checked) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      
      const onChangeVal = [...detailObj];
      onChangeVal[processIndex].showreport = checked;
      setdetailObj(onChangeVal);
      
      console.log(`Process ${processIndex + 1} showreport changed:`, {
        processIndex,
        checked,
        updatedDetail: onChangeVal[processIndex],
        allProcesses: onChangeVal.map((item, idx) => ({
          index: idx,
          process: item.PQR_Process,
          showreport: item.showreport
        }))
      });
    };

    // Debug: Log detailObj changes
    useEffect(() => {
      console.log('=== DETAIL OBJ CHANGED ===');
      console.log('Current detailObj showreport states:', detailObj.map((item, idx) => ({
        index: idx,
        process: item.PQR_Process,
        showreport: item.showreport,
        showreportType: typeof item.showreport
      })));
      console.log('==========================');
    }, [detailObj]);
    const validate = async (detaildata) => {
      // Ensure Wld_createdon_year is set before validation
      if (!headerObj.Wld_createdon_year) {
        headerObj.Wld_createdon_year = new Date().getFullYear();
      }

      // Use unified validation system
      const validationResult = validatePQRForm({
        headerObj,
        detailObj: detailObj,
        WPStype,
        currentErrors: error,
        pageType: "page1",
        setError,
        fieldPWHT,
      });

      let isError = validationResult.isError;

      // Check for duplicate PQR Record No
      if (
        (action === Action.ActionCopy || action === Action.ActionAdd) &&
        !isError
      ) {
        const duplicateResult = await validatePQRDuplicate(
          checkDuplicate,
          WPStype,
          headerObj.Wld_createdon_year,
          headerObj.PQR_RecordNo,
        );
        if (duplicateResult.isError) {
          isError = true;
          setError((prevState) => ({
            ...prevState,
            ...duplicateResult.error,
          }));
        }
      }

      // Validate process requirements
      const processValidation = validatePQRProcesses(
        detailObj,
        checkPQRProcessAdded,
        checkduplicateProcess,
      );

      if (processValidation.isError) {
        isError = true;
      }
      return isError;
    };
    const checkDuplicate = async (type, proj, revno) => {
      let reqParam = { groovetype: type, pkid: proj, skid: revno };
      let result = await getbyprojectno(reqParam);
      return result && result[0] !== undefined;
    };

    const validateTemp = async () => {
      let isError = false;
      let temperror = emptyError(error, setError, false);
      // Ensure Wld_createdon_year is set before validation
      if (!headerObj.Wld_createdon_year) {
        headerObj.Wld_createdon_year = new Date().getFullYear();
      }

      // Basic PQR Record No validation
      if (headerObj.PQR_RecordNo.trim() === "") {
        headerObj.PQR_RecordNo = "";
        isError = true;
        setError((prevState) => ({
          ...prevState,
          PQR_RecordNo: {
            status: true,
            message: "This field is required",
          },
        }));
      }

      // Check for duplicate PQR Record No
      if (
        (action === Action.ActionCopy || action === Action.ActionAdd) &&
        !isError
      ) {
        const duplicateResult = await validatePQRDuplicate(
          checkDuplicate,
          WPStype,
          headerObj.Wld_createdon_year,
          headerObj.PQR_RecordNo,
        );
        if (duplicateResult.isError) {
          isError = true;
          setError((prevState) => ({
            ...prevState,
            ...duplicateResult.error,
          }));
        }
      }

      // Validate process requirements
      const processValidation = validatePQRProcesses(
        detailObj,
        checkPQRProcessAdded,
        checkduplicateProcess,
      );

      if (processValidation.isError) {
        isError = true;
      }

      return { isError: isError, temperror };
    };

    const handleAdd = async (approvalstatus) => {
      let result;

      headerObj.PQR_Division = division[0].value;

      headerObj.WPSH_Status = approvalstatus;
      if (action == Action.ActionCopy)
        headerObj.WPSH_Status = Status.StatusTempSaved;

      let WPSH_PQR_Process = "";
      let WPSH_PQR_new = "";
      let WPSH_PQR_Type = "";
      let WPSH_PQR_Classification = "";
      let WPSH_PQR_TradeName = "";

      let PQRDetail = detailObj.filter(
        (i) => i.PQR_Process !== "NA" && i.PQR_Process !== "",
      );

      PQRDetail.map((item) => {
        item.PQR_RecordNo = headerObj.PQR_RecordNo;
        item.wld_WPSType = headerObj.wld_WPSType;
        item.PQR_WelderName = headerObj.PQR_WelderName;
        item.PQR_BM_WTBM_Pno = headerObj.PQR_BM_WTBM_Pno;
        item.PQR_BMT_Plate_thickness_RangeQ_Overlay =
          headerObj.PQR_BMT_Plate_thickness_RangeQ_Overlay;
        item.PQR_BMT_Pipe_Diameter_RangeQ_Overlay =
          headerObj.PQR_BMT_Pipe_Diameter_RangeQ_Overlay;

        item.PK = headerObj.wld_WPSType + "#" + headerObj.PQR_RecordNo;
        WPSH_PQR_Process += item.PQR_Process + ",";
        WPSH_PQR_Type += item.PQR_Type;
        WPSH_PQR_new += item.PQR_new;
        WPSH_PQR_Classification += item.PQRD_FM_Classification + ",";
        WPSH_PQR_TradeName += item.PQRD_FM_TradeName + ",";

        item.SK = item.PQR_Process + "#" + item.PQR_Type;
        
        // Initialize showreport to false for new data, keep undefined for old data
        if (item.showreport === undefined) {
          item.showreport = false;
        }
      });

      let PG1Add = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PQR_WPS_RecordNo: headerObj.PQR_WPS_RecordNo,
        WPSH_PQR_Process: WPSH_PQR_Process,
        WPSH_PQR_Type: WPSH_PQR_Type,
        WPSH_PQR_Classification: WPSH_PQR_Classification,
        WPSH_PQR_TradeName: WPSH_PQR_TradeName,
        WPSH_Status: headerObj.WPSH_Status,
        Pdf_images: headerObj.Pdf_images,
        detail_SK: headerObj.detail_SK,
        CheckboxPostWHT: headerObj?.CheckboxPostWHT,
        PWHT: headerObj.PWHT,
      };
      let PG1Update = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PQR_ReviNo: headerObj.PQR_ReviNo,
        PQR_WPS_RecordNo: headerObj.PQR_WPS_RecordNo,
        PQR_WPS_ReviNo: headerObj.PQR_WPS_ReviNo,
        PQR_DOB: headerObj.PQR_DOB,
        PQR_CompanyName: headerObj.PQR_CompanyName,
        PQR_WeldingStandard: headerObj.PQR_WeldingStandard,
        PQR_ReferenceCode: headerObj.PQR_ReferenceCode,
        WPSH_PQR_Process: WPSH_PQR_Process,
        WPSH_PQR_Type: WPSH_PQR_Type,
        WPSH_PQR_Classification: WPSH_PQR_Classification,
        WPSH_PQR_TradeName: WPSH_PQR_TradeName,
      };

      let PG1Images = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PQR_WPS_RecordNo: headerObj.PQR_WPS_RecordNo,
        Pdf_images: headerObj.Pdf_images,
        PQR_Image_Notes: headerObj.PQR_Address,
      };

      let PG1BM = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PQR_BM_BM_ProductForm: headerObj.PQR_BM_BM_ProductForm,
        PQR_BM_BM_Spec: headerObj.PQR_BM_BM_Spec,
        PQR_BM_BM_Pno: headerObj.PQR_BM_BM_Pno,
        PQR_BM_BM_Gno: headerObj.PQR_BM_BM_Gno,
        PQR_BM_BM_Size: headerObj.PQR_BM_BM_Size,
        PQR_BM_BM_Sch: headerObj.PQR_BM_BM_Sch,
        PQR_BM_BM_Thk: headerObj.PQR_BM_BM_Thk,
        PQR_BM_BM_Dia: headerObj.PQR_BM_BM_Dia,
        PQR_BM_WTBM_ProductForm: headerObj.PQR_BM_WTBM_ProductForm,
        PQR_BM_WTBM_Spec: headerObj.PQR_BM_WTBM_Spec,
        PQR_BM_WTBM_Pno: headerObj.PQR_BM_WTBM_Pno,
        PQR_BM_WTBM_Gno: headerObj.PQR_BM_WTBM_Gno,
        PQR_BM_WTBM_Size: headerObj.PQR_BM_WTBM_Size,
        PQR_BM_WTBM_Sch: headerObj.PQR_BM_WTBM_Sch,
        PQR_BM_WTBM_Thk: headerObj.PQR_BM_WTBM_Thk,
        PQR_BM_WTBM_Dia: headerObj.PQR_BM_WTBM_Dia,
        // PQR_BM_BM_Condition1: headerObj.PQR_BM_BM_Condition1,
        // PQR_BM_BM_Condition2: headerObj.PQR_BM_BM_Condition2,
        PQR_BM_HeatTreatmentCondition: headerObj.PQR_BM_HeatTreatmentCondition,
        PQR_BM_BM_Notes: headerObj.PQR_BM_BM_Notes,
        CheckboxPostWHT: headerObj.CheckboxPostWHT,
        PQR_WPS_RecordNo: headerObj.PQR_WPS_RecordNo,
        PWHT: headerObj.PWHT,
      };

      let PG1JD = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PQR_JD_JointDesign: headerObj.PQR_JD_JointDesign,
        PQR_JD_Backing: headerObj.PQR_JD_Backing,
        PQR_JD_Retainers: headerObj.PQR_JD_Retainers,
        PQR_JD_GrooveAngle: headerObj.PQR_JD_GrooveAngle,
        PQR_JD_RootOpening: headerObj.PQR_JD_RootOpening,
        PQR_JD_RootFace: headerObj.PQR_JD_RootFace,
        PQR_JD_Notes: headerObj.PQR_JD_Notes,
        PQR_WPS_RecordNo: headerObj.PQR_WPS_RecordNo,
      };

      let PG1PWHT = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PQR_PWHeatTre_Temperature: headerObj.PQR_PWHeatTre_Temperature,
        PQR_PWHeatTre_Time: headerObj.PQR_PWHeatTre_Time,
        PQR_PWHeatTre_Type: headerObj.PQR_PWHeatTre_Type,
        PQR_PWHeatTre_Heating_Rate: headerObj.PQR_PWHeatTre_Heating_Rate,
        PQR_PWHeatTre_Heating_Method: headerObj.PQR_PWHeatTre_Heating_Method,
        PQR_PWHeatTre_Cooling_Rate: headerObj.PQR_PWHeatTre_Cooling_Rate,
        PQR_PWHeatTre_Cooling_Method: headerObj.PQR_PWHeatTre_Cooling_Method,
        PQR_PWHeatTre_Notes: headerObj.PQR_PWHeatTre_Notes,
        PQR_PWHeatTre_Maintenance: headerObj.PQR_PWHeatTre_Maintenance,
        WPSH_Status: headerObj.WPSH_Status,
        WPSH_Approval_Status: headerObj.WPSH_Status,
        CheckboxPostWHT: headerObj.CheckboxPostWHT,
        PWHT: headerObj.PWHT,
        PQR_WPS_RecordNo: headerObj.PQR_WPS_RecordNo,
      };

      const postAdd = [PG1Add];
      let postUpdate = [PG1Update, PG1Images, PG1BM, PG1JD, PG1PWHT];

      // Debug: Log the data being sent
      console.log('=== PQR SUBMIT DEBUG ===');
      console.log('Action:', action);
      console.log('PQRDetail with showreport flags:', PQRDetail.map(item => ({
        process: item.PQR_Process,
        type: item.PQR_Type,
        showreport: item.showreport
      })));
      console.log('========================');

      // Add test data for copy action
      if (action === Action.ActionCopy) {
        const testObjects = createPQRTestDataObjects(headerObj);
        postUpdate = [...postUpdate, ...Object.values(testObjects)];
      }

      result = await AddUpdatePQRHeader(postAdd, postUpdate, action, setaction)
        .catch((err) => {
          console.error('AddUpdatePQRHeader error:', err);
          return false;
        });

      console.log('AddUpdatePQRHeader result:', result);

      if (result !== MessageTypes.SpecialCharacters && result !== false) {
        prevdetailobj.map(async (old) => {
          let res = PQRDetail.find((newdetail) => {
            return (
              newdetail.PQR_Process + "#" + newdetail.PQR_Type ===
              old.Process + "#" + old.Type
            );
          });
          if (res == undefined && old.Process != "") {
            await DeletePQRProcess(
              headerObj.wld_WPSType + "#" + headerObj.PQR_RecordNo,
              old.Process + "#" + old.Type,
            );
          }
        });
        await Promise.all(
          PQRDetail.map(async (detailrow) => {
            await AddNewDetail(detailrow)
              .catch((err) => {})
              .then((r) => {
                if (
                  r != undefined &&
                  r.data != undefined &&
                  r.data.message == MessageTypes.SpecialCharacters
                )
                  result = MessageTypes.SpecialCharacters;
              });
          }),
        );

        await handleImageUploads();
      }

      let oldval = [];
      detailObj.forEach((process) => {
        let prc = { Process: process.PQR_Process, Type: process.PQR_Type };
        oldval.push(prc);
      });
      if (result !== MessageTypes.SpecialCharacters) {
        setaction(Action.ActionEdit);
      }
      setprevdetailObj(oldval);
      return result;
    };

    const handleImageUploads = async () => {
      try {
        const imageUploads = [
          {
            profile,
            imageKey: headerObj?.Pdf_images?.[0]?.pqr_image1?.[0],
            setPreview: setPreviewUrl1,
            setView: setImageView1,
          },
          {
            profile: profile1,
            imageKey: headerObj?.Pdf_images?.[1]?.pqr_image2?.[0],
            setPreview: setPreviewUrl2,
            setView: setImageView2,
          },
        ];

        for (const { profile, imageKey, setPreview, setView } of imageUploads) {
          if (profile !== "" && imageKey !== "") {
            try {
              const result = await getPresignedURL(folderPQR, imageKey);
              if (!result?.url) { continue; }
              const posturl = result.url;
              setPreview(posturl);
              await axios.put(posturl, profile);
              setView(true);
            } catch (err) { continue; }
          }
        }
      } catch (error) {
        console.error("Error uploading images:", error);
    }
    };

    const commonFetch = createCommonFetchUtilities({
      getActiveProcess,
      getPNOActive,
      getActiveFno,
      getActiveAno,
      getActiveSfa,
    });

    useEffect(() => {
      commonFetch.fetchAllWeldingData({
        setProcessActive,
        setPNoActive,
        setFnoActive,
        setAnoActive,
        setSfaActive,
      });
    }, []);
    const fetchImages1 = async (item) => {
      await fetchImagePreview(
        folderPQR,
        item,
        setPreviewUrl1,
        ""
      );
    };

    const fetchImages2 = async (item) => {
      await fetchImagePreview(folderPQR, item, setPreviewUrl2, "");
    };
    useEffect(() => {
      if (
        (action === Action.ActionEdit || action === Action.ActionCopy) &&
        headerObj?.Pdf_images?.[0]?.pqr_image1?.[0]
      ) {
        fetchImages1(headerObj.Pdf_images[0].pqr_image1[0]);
      }
      if (
        (action === Action.ActionEdit || action === Action.ActionCopy) &&
        headerObj?.Pdf_images?.[1]?.pqr_image2?.[0]
      ) {
        fetchImages2(headerObj.Pdf_images[1].pqr_image2[0]);
      }
      setImageView1(true);
      setImageView2(true);
    }, []);

    useEffect(() => {
      if (ImageView1 === true && headerObj?.Pdf_images?.[0]?.pqr_image1?.[0]) {
        fetchImages1(headerObj.Pdf_images[0].pqr_image1[0]);
      }
    }, [headerObj.Pdf_images, ImageView1]);

    useEffect(() => {
      if (ImageView2 === true && headerObj?.Pdf_images?.[1]?.pqr_image2?.[0]) {
        fetchImages2(headerObj.Pdf_images[1].pqr_image2[0]);
      }
    }, [headerObj.Pdf_images, ImageView2]);

    const fileInputRef = useRef(null);
    const handleSubmit = () =>
      handlePQRGeneralSubmit(
        validate,
        handleAdd,
        setLoading,
        headerObj.WPSH_Status,
      );

    const handleSubmitTemp = () =>
      handlePQRGeneralSubmitTemp(
        isEdited,
        validateTemp,
        handleAdd,
        setLoading,
        setIsEdited,
        headerObj?.WPSH_Status,
      );

    useImperativeHandle(ref, () => ({
      funcOnNext: async () => {
        let res = false;
        res = await handleSubmit();

        return res;
      },

      funcOnNextTemp: async () => {
        let res = false;
        res = await handleSubmitTemp();
        return res;
      },
    }));

    const handleFile1 = (file, index, e) => {
      if (validateFile(file)) {
            if (!headerObj.Pdf_images) {
      headerObj.Pdf_images = [{ pqr_image1: [""] }, { pqr_image2: [""] }];
    }
        if (index === 0) {
          setProfile(file);
          setPreviewUrl1(URL.createObjectURL(file));
          console.log("images", headerObj.Pdf_images)
          headerObj.Pdf_images[0].pqr_image1[0] = file.name;
        } else if (index === 1) {
          setProfile1(file);
          setPreviewUrl2(URL.createObjectURL(file));
          headerObj.Pdf_images[1].pqr_image2[0] = file.name;
        }
      }
    };
    const updatePWHTFields = (checked) => {
      const baseUpdate = { CheckboxPostWHT: checked };
      if (!checked) {
        return {
          ...baseUpdate,
          PQR_PWHeatTre_Temperature: "Not Applicable",
          PQR_PWHeatTre_Time: "Not Applicable",
          PQR_PWHeatTre_Type: "Not Applicable",
        };
      }
      return baseUpdate;
    };

    const handleCheckboxChange = (e) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      setIsChecked(e.target.checked);
      setFieldPWHT(!e.target.checked);
      setheaderObj((header) => ({
        ...header,
        ...updatePWHTFields(e.target.checked),
      }));
    };




    return (
      <Row>
        {loading && (
          <div className="loader-overlay">
            <DotLoader size={80} className="pageloader" />
          </div>
        )}
        <div className="common-padding font">
          <Row className="PQR-Page-row-padding">
            <Row>
              <Col md={3} className="mb-1">
                <Form.Group>
                  <SingleInput
                    name="PQR_RecordNo"
                    type="text"
                    maxLength={12}
                    readOnly={isReadonly}
                    status={error.PQR_RecordNo.status}
                    value={headerObj?.PQR_RecordNo}
                    disabled={action === Action.ActionEdit ? true : false}
                    onChange={(e) => {
                      handleChange(e);
                      if (action == Action.ActionCopy) {
                        setIsDisabled(false);
                      }
                    }}
                    allowlistfunction={SquareBracketNotAllowed}
                    allowcharacters="/\-"
                    customMessage="Special Characters # % + $ ' < > = &; not allowed"
                    setError={setError}
                    error={error}
                    label="PQR Record No."
                    message={error.PQR_RecordNo.message}
                  ></SingleInput>
                </Form.Group>
              </Col>
               {/* <Col md={3}>
                <Form.Group>
                  <SingleInput
                    name="PQR_ReviNo"
                    type="text"
                    maxLength={2}
                    readOnly={isReadonly}
                    status={error.PQR_ReviNo.status}
                    value={headerObj?.PQR_ReviNo}
                    onChange={handleChange}
                    label="Revision"
                    disabled={isDisabled}
                    message={error.PQR_ReviNo.message}
                    setError={setError}
                    error={error}
                  ></SingleInput>
                </Form.Group>
              </Col> */}
              <Col md={3}>
                <Form.Group>
                  <SingleInput
                    name="PQR_WPS_RecordNo"
                    type="text"
                    maxLength={25}
                    status={error.PQR_WPS_RecordNo.status}
                    disabled={action === Action.ActionEdit ? true : false}
                    value={headerObj?.PQR_WPS_RecordNo}
                    onChange={handleChange}
                    allowlistfunction={SquareBracketNotAllowed}
                    allowcharacters="+-"
                  customMessage="Special Characters # %  $ ' < > = &; not allowed"
                    readOnly={isReadonly}
                    label="WPS Record No."
                    label1=""
                    message={error.PQR_WPS_RecordNo.message}
                    setError={setError}
                    error={error}
                  ></SingleInput>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <SingleInput
                    name="PQR_WPS_ReviNo"
                    type="text"
                    maxLength={2}
                    readOnly={isReadonly}
                    status={error.PQR_WPS_ReviNo.status}
                    value={headerObj?.PQR_WPS_ReviNo}
                    onChange={handleChange}
                    label="WPS Revision No."
                    label1=""
                    message={error.PQR_WPS_ReviNo.message}
                    setError={setError}
                    error={error}
                    disabled={isDisabled}
                  ></SingleInput>
                </Form.Group>
              </Col>
              <Col md={3}>
                <DateInputUser
                  divClass="T-input w-100"
                  label="Date"
                  className="groove_datecolor"
                  name="PQR_DOB"
                  obj={headerObj}
                  todayDate={todayDate}
                  setobj={setheaderObj}
                  setError={setError}
                  status={error.PQR_DOB.status}
                  message={error.PQR_DOB.message}
                  disabled={isDisabled}
                />
              </Col>
              <Col md={3}>
                <Form.Group>
                  <General_Single_Input_select
                    name="PQR_CompanyName"
                    type="text"
                    readOnly={isReadonly}
                    status={error.PQR_CompanyName.status}
                    value={headerObj?.PQR_CompanyName}
                    handleSelectChange={handleChange}
                    label="Company Name "
                    message={error.PQR_CompanyName.message}
                    array={Company_Name}
                    disabled={isDisabled}
                  ></General_Single_Input_select>
                </Form.Group>
              </Col>

              <Col md={3}>
                {!isoverlay ? (
                  <Form.Group>
                    <SingleInput
                      name="PQR_ReferenceCode"
                      type="text"
                      maxLength={40}
                      readOnly={isReadonly}
                      status={error.PQR_ReferenceCode.status}
                      value={headerObj?.PQR_ReferenceCode}
                      onChange={handleChange}
                      allowlistfunction={SquareBracketNotAllowed}
                      allowcharacters="/+&\-"
                      customMessage="Special Characters # %  $ ' < > = ; not allowed"
                      label="Reference Code"
                      label1=""
                      message={error.PQR_ReferenceCode.message}
                      setError={setError}
                      error={error}
                      disabled={isDisabled}
                    ></SingleInput>
                  </Form.Group>
                ) : (
                  <Form.Group>
                    <General_Single_Input_select
                      name="PQR_WeldingStandard"
                      type="text"
                      readOnly={isReadonly}
                      status={error.PQR_WeldingStandard.status}
                      value={headerObj?.PQR_WeldingStandard}
                      handleSelectChange={handleChange}
                      label="Welding Standard"
                      message={error.PQR_WeldingStandard.message}
                      array={Welding_Standard}
                      disabled={isDisabled}
                    ></General_Single_Input_select>
                  </Form.Group>
                )}
              </Col>
            </Row>
          </Row>
          <Row className="PQR-Page-row-padding bg-white mb-2">
            <Row className="mb-2">
              <Col md={12}>
                <p
                  className="WPS-blue-text "
                  style={{ position: "relative", top: "10px" }}
                >
                  Base Metals{" "}
                </p>
                <BaseMetalTablePQR
                  headerObj={headerObj}
                  setheaderObj={setheaderObj}
                  error={error}
                  isReadonly={isReadonly}
                  handleChange={handleChange}
                  setError={setError}
                  PNoActive={PNoActive}
                  blyestyle={blyestyle}
                  errorstyle={errorstyle}
                  isDisabled={isDisabled}
                ></BaseMetalTablePQR>
              </Col>
            </Row>
            <Row className="mb-2">
              {/* {!isoverlay ? (
                <Col md={6} className="mb-1">
                  <Form.Group>
                    <SingleInput
                      name="PQR_BM_BM_Condition1"
                      type="text"
                      maxLength={25}
                      readOnly={isReadonly}
                      status={error.PQR_BM_BM_Condition1.status}
                      value={headerObj?.PQR_BM_BM_Condition1}
                      onChange={handleChange}
                      label="Base Material Condition 1"
                      message={error.PQR_BM_BM_Condition1.message}
                      setError={setError}
                      error={error}
                      disabled={isDisabled}
                    ></SingleInput>
                  </Form.Group>
                </Col>
              ) : (
                ""
              )}
              {!isoverlay ? (
                <Col md={6} className="mb-1">
                  <Form.Group>
                    <SingleInput
                      name="PQR_BM_BM_Condition2"
                      type="text"
                      maxLength={25}
                      readOnly={isReadonly}
                      status={error.PQR_BM_BM_Condition2.status}
                      value={headerObj?.PQR_BM_BM_Condition2}
                      onChange={handleChange}
                      label="Base Material Condition 2"
                      message={error.PQR_BM_BM_Condition2.message}
                      setError={setError}
                      error={error}
                      disabled={isDisabled}
                    ></SingleInput>
                  </Form.Group>
                </Col>
              ) : (
                ""
              )} */}
              {!isoverlay ? (
                <Col md={12}>
                  <Form.Group>
                    <SingleInput
                      name="PQR_BM_HeatTreatmentCondition"
                      type="text"
                      maxLength={24}
                      readOnly={isReadonly}
                      status={error.PQR_BM_HeatTreatmentCondition.status}
                      value={headerObj?.PQR_BM_HeatTreatmentCondition}
                      onChange={handleChange}
                      label="Heat Treatment Condition"
                      message={error.PQR_BM_HeatTreatmentCondition.message}
                      setError={setError}
                      allowlistfunction={SquareBracketNotAllowed}
                      allowcharacters="-/+&"
                      customMessage="Special Characters # % $ ' < > = ; not allowed"
                      error={error}
                      disabled={isDisabled}
                    ></SingleInput>
                  </Form.Group>
                </Col>
              ) : (
                ""
              )}
              <Col md={12}>
                <Form.Group>
                  <SingleInput
                    name="PQR_BM_BM_Notes"
                    type="text"
                    maxLength={85}
                    readOnly={isReadonly}
                    status={error.PQR_BM_BM_Notes.status}
                    value={headerObj?.PQR_BM_BM_Notes}
                    onChange={handleChange}
                    label="Notes"
                    message={error.PQR_BM_BM_Notes.message}
                    setError={setError}
                    allowlistfunction={SquareBracketNotAllowed}
                    allowcharacters="+&±/-"
                    customMessage="Special Characters # % $ ' < > = not allowed"
                    error={error}
                    disabled={isDisabled}
                  ></SingleInput>
                </Form.Group>
              </Col>
            </Row>
          </Row>
          <Row className="PQR-Page-row-padding mb-4">
            <Row>
              <Row className="mb-4">
                <div className="checkboxproject">
                  <input
                    type="checkbox"
                    placeholder=" "
                    id="chkcode"
                    className="form-check-input"
                    name="CheckboxPostWHT"
                    onClick={(e) => {
                      setIsChecked(e.target.checked);
                      if (e.target.checked === false) {
                        setheaderObj((prevState) => ({
                          ...prevState,
                          PQR_PWHeatTre_Temperature: "Not Applicable",
                          PQR_PWHeatTre_Time: "Not Applicable",
                          PQR_PWHeatTre_Type: "Not Applicable",
                          PQR_PWHeatTre_Heating_Rate: "Not Applicable",
                          PQR_PWHeatTre_Heating_Method: "Not Applicable",
                          PQR_PWHeatTre_Cooling_Rate: "Not Applicable",
                          PQR_PWHeatTre_Cooling_Method: "Not Applicable",
                          PQR_PWHeatTre_Notes: "Not Applicable",
                          PQR_PWHeatTre_Maintenance: "Not Applicable",
                          PWHT: "No",
                        }));
                        setError((prevState) => ({
                          ...prevState,
                          PQR_PWHeatTre_Temperature: {
                            status: false,
                            message: "",
                          },
                          PQR_PWHeatTre_Time: { status: false, message: "" },
                          PQR_PWHeatTre_Type: { status: false, message: "" },
                          PQR_PWHeatTre_Heating_Rate: {
                            status: false,
                            message: "",
                          },
                          PQR_PWHeatTre_Heating_Method: {
                            status: false,
                            message: "",
                          },
                          PQR_PWHeatTre_Cooling_Rate: {
                            status: false,
                            message: "",
                          },
                          PQR_PWHeatTre_Cooling_Method: {
                            status: false,
                            message: "",
                          },
                          PQR_PWHeatTre_Notes: { status: false, message: "" },
                          PQR_PWHeatTre_Maintenance: {
                            status: false,
                            message: "",
                          },
                        }));
                      } else {
                        setheaderObj((prevState) => ({
                          ...prevState,
                          PQR_PWHeatTre_Temperature: "",
                          PQR_PWHeatTre_Time: "",
                          PQR_PWHeatTre_Type: "",
                          PQR_PWHeatTre_Heating_Rate: "",
                          PQR_PWHeatTre_Heating_Method: "",
                          PQR_PWHeatTre_Cooling_Rate: "",
                          PQR_PWHeatTre_Cooling_Method: "",
                          PQR_PWHeatTre_Notes: "",
                          PQR_PWHeatTre_Maintenance: "",
                          PWHT: "Yes",
                        }));
                      }
                    }}
                    onChange={handleCheckboxChange}
                    defaultChecked={
                      headerObj?.PQR_PWHeatTre_Temperature == "Not Applicable"
                        ? false
                        : isChecked
                    }
                  />
                  &nbsp;&nbsp;
                  <span
                    className="WPS-blue-text"
                    style={{ position: "relative", bottom: "-2px" }}
                  >
                    Post Weld Heat Treatment (QW-407)
                  </span>
                </div>
              </Row>
              <Row className="mb-1">
                <Col className="mb-1" md={3}>
                  <SingleInput
                    disabled={
                      headerObj?.PQR_PWHeatTre_Temperature == "Not Applicable"
                        ? true
                        : false
                    }
                    name="PQR_PWHeatTre_Temperature"
                    type="text"
                    maxLength={20}
                    status={error.PQR_PWHeatTre_Temperature.status}
                    value={headerObj?.PQR_PWHeatTre_Temperature}
                    onChange={handleChange}
                    label="Temperarture(°C)"
                    message={error.PQR_PWHeatTre_Temperature.message}
                    setError={setError}
                     allowlistfunction={SquareBracketNotAllowed}
                    allowcharacters="+&±+°/-"
                  customMessage="Special Characters # %  $ ' < > = ; not allowed"
                    error={error}
                  ></SingleInput>
                </Col>
                <Col className="mb-1" md={3}>
                  <SingleInput
                    disabled={
                      headerObj?.PQR_PWHeatTre_Temperature == "Not Applicable"
                        ? true
                        : false
                    }
                    name="PQR_PWHeatTre_Time"
                    type="text"
                    maxLength={28}
                    status={error.PQR_PWHeatTre_Time.status}
                    value={headerObj?.PQR_PWHeatTre_Time}
                    onChange={handleChange}
                    label="Time (Minutes)"
                    message={error.PQR_PWHeatTre_Time.message}
                    setError={setError}
                     allowlistfunction={SquareBracketNotAllowed}
                    allowcharacters="+&±+°/-"
                  customMessage="Special Characters # %  $ ' < > =; not allowed"
                    error={error}
                  ></SingleInput>
                </Col>
                <Col className="mb-1" md={3}>
                  <SingleInput
                    disabled={
                      headerObj?.PQR_PWHeatTre_Temperature == "Not Applicable"
                        ? true
                        : false
                    }
                    name="PQR_PWHeatTre_Type"
                    type="text"
                    maxLength={18}
                    status={error.PQR_PWHeatTre_Type.status}
                    value={headerObj?.PQR_PWHeatTre_Type}
                    onChange={handleChange}
                    label="Type"
                    message={error.PQR_PWHeatTre_Type.message}
                    setError={setError}
                     allowlistfunction={SquareBracketNotAllowed}
                    allowcharacters="+&±+°/-"
                  customMessage="Special Characters # %  $ ' < > = ; not allowed"
                    error={error}
                  ></SingleInput>
                </Col>
              </Row>
              <Row className="mb-1">
                <Col className="mb-1" md={3}>
                  <SingleInput
                    disabled={
                      headerObj?.PQR_PWHeatTre_Temperature == "Not Applicable"
                        ? true
                        : false
                    }
                    name="PQR_PWHeatTre_Heating_Rate"
                    type="text"
                    maxLength={20}
                    status={error.PQR_PWHeatTre_Heating_Rate.status}
                    value={headerObj?.PQR_PWHeatTre_Heating_Rate}
                    onChange={handleChange}
                    label="Heating Rate (C/Hr)"
                    message={error.PQR_PWHeatTre_Heating_Rate.message}
                    setError={setError}
                     allowlistfunction={SquareBracketNotAllowed}
                    allowcharacters="+&±+°/-"
                  customMessage="Special Characters # %  $ ' < > = ; not allowed"
                    error={error}
                  ></SingleInput>
                </Col>
                <Col className="mb-1" md={3}>
                  <SingleInput
                    disabled={
                      headerObj?.PQR_PWHeatTre_Temperature == "Not Applicable"
                        ? true
                        : false
                    }
                    name="PQR_PWHeatTre_Heating_Method"
                    type="text"
                    maxLength={20}
                    status={error.PQR_PWHeatTre_Heating_Method.status}
                    value={headerObj?.PQR_PWHeatTre_Heating_Method}
                    onChange={handleChange}
                    label="Loading Temperature °C"
                    message={error.PQR_PWHeatTre_Heating_Method.message}
                    setError={setError}
                    error={error}
                     allowlistfunction={SquareBracketNotAllowed}
                    allowcharacters="+&±+°/-"
                  customMessage="Special Characters # %  $ ' < > = ; not allowed"
                  ></SingleInput>
                </Col>
                <Col className="mb-1" md={3}>
                  <SingleInput
                    disabled={
                      headerObj?.PQR_PWHeatTre_Temperature == "Not Applicable"
                        ? true
                        : false
                    }
                    name="PQR_PWHeatTre_Cooling_Rate"
                    type="text"
                    maxLength={20}
                    status={error.PQR_PWHeatTre_Cooling_Rate.status}
                    value={headerObj?.PQR_PWHeatTre_Cooling_Rate}
                    onChange={handleChange}
                    label=" Cooling Rate (C/Hr)"
                    message={error.PQR_PWHeatTre_Cooling_Rate.message}
                    setError={setError}
                     allowlistfunction={SquareBracketNotAllowed}
                    allowcharacters="+&±+°/-"
                  customMessage="Special Characters # %  $ ' < > = ; not allowed"
                    error={error}
                  ></SingleInput>
                </Col>
                <Col className="mb-1" md={3}>
                  <SingleInput
                    disabled={
                      headerObj?.PQR_PWHeatTre_Temperature == "Not Applicable"
                        ? true
                        : false
                    }
                    name="PQR_PWHeatTre_Cooling_Method"
                    type="text"
                    maxLength={20}
                    status={error.PQR_PWHeatTre_Cooling_Method.status}
                    value={headerObj?.PQR_PWHeatTre_Cooling_Method}
                    onChange={handleChange}
                    label="Unloading Temperature °C"
                    message={error.PQR_PWHeatTre_Cooling_Method.message}
                    setError={setError}
                     allowlistfunction={SquareBracketNotAllowed}
                    allowcharacters="+&±+°/-"
                  customMessage="Special Characters # %  $ ' < > = ; not allowed"
                    error={error}
                  ></SingleInput>
                </Col>
              </Row>
              <Row className="mb-1">
                <Col className="mb-1" md={12}>
                  <SingleInput
                    disabled={
                      headerObj?.PQR_PWHeatTre_Temperature == "Not Applicable"
                        ? true
                        : false
                    }
                    name="PQR_PWHeatTre_Notes"
                    type="text"
                    maxLength={73}
                    status={error.PQR_PWHeatTre_Notes.status}
                    message={error.PQR_PWHeatTre_Notes.message}
                    value={headerObj?.PQR_PWHeatTre_Notes}
                    onChange={handleChange}
                    label="Notes"
                    setError={setError}
                     allowlistfunction={SquareBracketNotAllowed}
                    allowcharacters="+&±+°/-"
                  customMessage="Special Characters # %  $ ' < > = ; not allowed"
                    error={error}
                  ></SingleInput>
                </Col>
              </Row>
              <Row className="mb-1">
                <Col md={12}>
                  <Form.Group>
                    <SingleInput
                      disabled={
                        headerObj?.PQR_PWHeatTre_Temperature == "Not Applicable"
                          ? true
                          : false
                      }
                      name="PQR_PWHeatTre_Maintenance"
                      type="text"
                      maxLength={30}
                      readOnly={isReadonly}
                      status={error.PQR_PWHeatTre_Maintenance.status}
                      value={headerObj?.PQR_PWHeatTre_Maintenance}
                      onChange={handleChange}
                      label="Preheat maintenance after completion of welding prior to PWHT ( QW-406.2)"
                      message={error.PQR_PWHeatTre_Maintenance.message}
                      setError={setError}
                       allowlistfunction={SquareBracketNotAllowed}
                    allowcharacters="+&±+°/-"
                  customMessage="Special Characters # %  $ ' < > = ; not allowed"
                      error={error}
                    ></SingleInput>
                  </Form.Group>
                </Col>
              </Row>
            </Row>
          </Row>
          {isoverlay ? (
            <Row
              style={{ position: "relative", bottom: "30px" }}
              className="PQR-Page-row-padding mb-8"
            >
              <Row className="mb-1">
                <Col md={12}>
                  <p
                    className="WPS-blue-text"
                    style={{ position: "relative", top: "10px" }}
                  >
                    Joints (QW - 402)
                  </p>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <SingleInput
                      name="PQR_JD_JointDesign"
                      type="text"
                      maxLength={20}
                      readOnly={isReadonly}
                      status={error.PQR_JD_JointDesign.status}
                      value={headerObj?.PQR_JD_JointDesign}
                      onChange={handleChange}
                      allowlistfunction={SquareBracketNotAllowed}
                      allowcharacters="/+&°±\-"
                      customMessage="Special Characters # % $ ' < > = ; not allowed"
                      label="Joint Design"
                      message={error.PQR_JD_JointDesign.message}
                      setError={setError}
                      error={error}
                      disabled={isDisabled}
                    ></SingleInput>
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group>
                    <SingleInput
                      name="PQR_JD_Notes"
                      type="text"
                      maxLength={25}
                      readOnly={isReadonly}
                      status={error.PQR_JD_Notes.status}
                      value={headerObj?.PQR_JD_Notes}
                      onChange={handleChange}
                      allowlistfunction={SquareBracketNotAllowed}
                      allowcharacters="/+&°±\-"
                      customMessage="Special Characters # % $ ' < > = ; not allowed"
                      label="Notes"
                      message={error.PQR_JD_Notes.message}
                      setError={setError}
                      error={error}
                      disabled={isDisabled}
                    ></SingleInput>
                  </Form.Group>
                </Col>
              </Row>
            </Row>
          ) : (
            <Row className="PQR-Page-row-padding mb-8">
              <Row className="mb-1">
                <Col md={12}>
                  <p
                    className="WPS-blue-text"
                    style={{ position: "relative", top: "10px" }}
                  >
                    Joints (QW - 402)
                  </p>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <SingleInput
                      name="PQR_JD_JointDesign"
                      type="text"
                      maxLength={20}
                      readOnly={isReadonly}
                      status={error.PQR_JD_JointDesign.status}
                      value={headerObj?.PQR_JD_JointDesign}
                      onChange={handleChange}
                      allowlistfunction={SquareBracketNotAllowed}
                      allowcharacters="/+&°±\-"
                      customMessage="Special Characters # % $ ' < > = ; not allowed"
                      label="Joint Design"
                      message={error.PQR_JD_JointDesign.message}
                      setError={setError}
                      error={error}
                      disabled={isDisabled}
                    ></SingleInput>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <SingleInput
                      name="PQR_JD_Backing"
                      type="text"
                      maxLength={20}
                      readOnly={isReadonly}
                      status={error.PQR_JD_Backing.status}
                      value={headerObj?.PQR_JD_Backing}
                      onChange={handleChange}
                      allowlistfunction={SquareBracketNotAllowed}
                      allowcharacters="/+&°±\-"
                      customMessage="Special Characters # % $ ' < > = ; not allowed"
                      label="Backing"
                      message={error.PQR_JD_Backing.message}
                      setError={setError}
                      error={error}
                      disabled={isDisabled}
                    ></SingleInput>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <SingleInput
                      name="PQR_JD_Retainers"
                      type="text"
                      maxLength={20}
                      readOnly={isReadonly}
                      status={error.PQR_JD_Retainers.status}
                      value={headerObj?.PQR_JD_Retainers}
                      onChange={handleChange}
                      allowlistfunction={SquareBracketNotAllowed}
                      allowcharacters="/+&°±\-"
                      customMessage="Special Characters # % $ ' < > = ; not allowed"
                      label="Retainers"
                      message={error.PQR_JD_Retainers.message}
                      setError={setError}
                      error={error}
                      disabled={isDisabled}
                    ></SingleInput>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <SingleInput
                      name="PQR_JD_GrooveAngle"
                      type="text"
                      maxLength={20}
                      readOnly={isReadonly}
                      status={error.PQR_JD_GrooveAngle.status}
                      value={headerObj?.PQR_JD_GrooveAngle}
                      onChange={handleChange}
                      allowlistfunction={SquareBracketNotAllowed}
                      allowcharacters="/+&°±\-"
                      customMessage="Special Characters # % $ ' < > = ; not allowed"
                      label="Groove Angle (deg) "
                      message={error.PQR_JD_GrooveAngle.message}
                      setError={setError}
                      error={error}
                      disabled={isDisabled}
                    ></SingleInput>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-1">
                <Col md={3}>
                  <Form.Group>
                    <SingleInput
                      name="PQR_JD_RootOpening"
                      type="text"
                      maxLength={20}
                      readOnly={isReadonly}
                      status={error.PQR_JD_RootOpening.status}
                      value={headerObj?.PQR_JD_RootOpening}
                      onChange={handleChange}
                      allowlistfunction={SquareBracketNotAllowed}
                      allowcharacters="/+&°±\-"
                      customMessage="Special Characters # % $ ' < > = ; not allowed"
                      label="Root Opening (mm)"
                      message={error.PQR_JD_RootOpening.message}
                      setError={setError}
                      error={error}
                      disabled={isDisabled}
                    ></SingleInput>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <SingleInput
                      name="PQR_JD_RootFace"
                      type="text"
                      readOnly={isReadonly}
                      maxLength={20}
                      status={error.PQR_JD_RootFace.status}
                      value={headerObj?.PQR_JD_RootFace}
                      onChange={handleChange}
                      allowlistfunction={SquareBracketNotAllowed}
                      allowcharacters="/+&°±\-"
                      customMessage="Special Characters # % $ ' < > = ; not allowed"
                      label="Root Face (mm)"
                      message={error.PQR_JD_RootFace.message}
                      setError={setError}
                      error={error}
                      disabled={isDisabled}
                    ></SingleInput>
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group>
                    <SingleInput
                      name="PQR_JD_Notes"
                      type="text"
                      maxLength={25}
                      readOnly={isReadonly}
                      status={error.PQR_JD_Notes.status}
                      value={headerObj?.PQR_JD_Notes}
                      onChange={handleChange}
                      allowlistfunction={SquareBracketNotAllowed}
                      allowcharacters="/+&°±\-"
                      customMessage="Special Characters # % $ ' < > = ; not allowed"
                      label="Notes"
                      message={error.PQR_JD_Notes.message}
                      setError={setError}
                      error={error}
                      disabled={isDisabled}
                    ></SingleInput>
                  </Form.Group>
                </Col>
              </Row>
            </Row>
          )}
          <Row
            style={{ position: "relative", height: "150px" }}
            className="PQR-Page-row-padding"
          >
            <ImageArray2
              headerObj={headerObj}
              setheaderObj={setheaderObj}
              type="file"
              accept="image/jpeg, image/png, image/jpg"
              fileInputRef={fileInputRef}
              handleFile={handleFile1}
              previewUrl1={previewUrl1}
              previewUrl2={previewUrl2}
              name1="fileInput1"
              name2="fileInput2"
              setPreviewUrl1={setPreviewUrl1}
              setPreviewUrl2={setPreviewUrl2}
            ></ImageArray2>
          </Row>
          <Row style={{ background: "white", position: "relative" }}>
            <Row className="mb-1">
              <Col md={12}>
                <p className="WPS-blue-text ">Welding Process </p>
                <PQRProcess
                  headerObj={headerObj}
                  detailObj={detailObj}
                  setdetailObj={setdetailObj}
                  ProcessActive={ProcessActive}
                  isReadonly={isReadonly}
                  toast={toast}
                  disabled={isDisabled}
                  handleProcessCheckboxChange={handleProcessCheckboxChange}
                  action={action}
                  setIsEdited={setIsEdited}
                />
                <Row
                  className="mb-4"
                  style={{
                    padding: "0px 8px",
                    opacity: isDisabled ? 0.5 : 1,
                    pointerEvents: isDisabled ? "none" : "auto",
                  }}
                >
                  <div className="scrollpqr">
                    <p className="WPS-blue-text ">Filler Metals (QW-404) </p>
                    <Col style={{ position: "relative", bottom: "8px" }}>
                      <Table
                        bordered
                        responsive="sm"
                        className="text-center same-col-widths align-middle"
                      >
                        <tbody>
                          <PQR_Process_Grid_Select
                            wps_detail={detailObj}
                            ColumnHeader="SFA Specification"
                            Columndimension=""
                            readOnly={isDisabled}
                            status={error.PQRD_FM_SFA.status}
                            message={error.PQRD_FM_SFA.message}
                            name="PQRD_FM_SFA"
                            array={SfaActive.map((item) => ({
                              value: item.wld_code,
                              name: item.wld_code,
                            }))}
                            handleChangedetailsarray={handleChangedetailsarray}
                          ></PQR_Process_Grid_Select>
                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="AWS Classification"
                            Columndimension=""
                            status={error.PQRD_FM_Classification.status}
                            message={error.PQRD_FM_Classification.message}
                            type="text"
                            width={272}
                            maxLength={24}
                            name="PQRD_FM_Classification"
                            handleChangedetailsarray={handleChangedetailsarray}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericWithDashSlashPlusAmpersand}
                            setError={setError}
                            onBlur={(e) => {
                              let error = isAlphanumericWithDashSlashPlusAmpersand(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_FM_Classification: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>
                          <PQR_Process_Grid_Select
                            wps_detail={detailObj}
                            ColumnHeader="Filler Metal F-Number"
                            Columndimension=""
                            status={error.PQRD_FM_FNo.status}
                            message={error.PQRD_FM_FNo.message}
                            name="PQRD_FM_FNo"
                            array={FnoActive.map((item) => ({
                              value: item.wld_code,
                              name: item.wld_code,
                            }))}
                            handleChangedetailsarray={handleChangedetailsarray}
                          ></PQR_Process_Grid_Select>
                          <PQR_Process_Grid_Select
                            wps_detail={detailObj}
                            ColumnHeader="Filler Metal A-Number"
                            Columndimension=""
                            status={error.PQRD_FM_Ano.status}
                            message={error.PQRD_FM_Ano.message}
                            name="PQRD_FM_Ano"
                            array={AnoActive.map((item) => ({
                              value: item.wld_code,
                              name: item.wld_code,
                            }))}
                            handleChangedetailsarray={handleChangedetailsarray}
                          ></PQR_Process_Grid_Select>
                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Filler Metal Nominal Composition"
                            Columndimension=""
                            status={error.PQRD_FM_Nominal.status}
                            message={error.PQRD_FM_Nominal.message}
                            type="text"
                            maxLength={35}
                            width={272}
                            name="PQRD_FM_Nominal"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericSpecialCharactersRestrictedChar}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericSpecialCharactersRestrictedChar(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_FM_Nominal: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Filler Metal Trade Name"
                            Columndimension=""
                            width={272}
                            status={error.PQRD_FM_TradeName.status}
                            message={error.PQRD_FM_TradeName.message}
                            type="text"
                            maxLength={35}
                            name="PQRD_FM_TradeName"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericSpecialCharactersRestrictedChar}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericSpecialCharactersRestrictedChar(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_FM_TradeName: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQR_Process_Grid_Select
                            wps_detail={detailObj}
                            ColumnHeader="Filler Metal Product Form"
                            status={error.PQRD_FM_ProductForm.status}
                            message={error.PQRD_FM_ProductForm.message}
                            name="PQRD_FM_ProductForm"
                            array={FM_Product_Form}
                            handleChangedetailsarray={handleChangedetailsarray}
                          ></PQR_Process_Grid_Select>
                          <PQRProcessGridInput3
                            wps_detail={detailObj}
                            ColumnHeader="Filler Metal Size"
                            Columndimension="mm"
                            status={error.PQRD_FM_FillerMetalSize.status}
                            message={error.PQRD_FM_FillerMetalSize.message}
                            type="text"
                            maxLength={8}
                            name="PQRD_FM_FillerMetalSize"
                            handleChange={handleChange3field}
                            onInput={(e) => {
                              let error = isAlphanumericMinusPlusPercentDiameter(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_FM_FillerMetalSize: error,
                              }));
                            }}
                          ></PQRProcessGridInput3>
                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Deposited Thickness"
                            Columndimension="mm"
                            status={error.PQRD_FM_DepositedThickness.status}
                            message={error.PQRD_FM_DepositedThickness.message}
                            type="text"
                            maxLength={7}
                            width={272}
                            name="PQRD_FM_DepositedThickness"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericAllSpecialCharacters}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericAllSpecialCharacters(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_FM_DepositedThickness: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Maximum Pass Thickness"
                            Columndimension="mm"
                            status={error.PQRD_FM_MaxPassThickness.status}
                            message={error.PQRD_FM_MaxPassThickness.message}
                            type="text"
                            maxLength={7}
                            width={272}
                            name="PQRD_FM_MaxPassThickness"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericAllSpecialCharacters}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericAllSpecialCharacters(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_FM_MaxPassThickness: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>
                          {isoverlay ? (
                            <PQRFillerMetalInput
                              wps_detail={detailObj}
                              ColumnHeader="Weld Deposit Chemistry"
                              Columndimension=""
                              status={error.PQRD_FM_WeldDepositChemistry.status}
                              message={
                                error.PQRD_FM_WeldDepositChemistry.message
                              }
                              type="text"
                              maxLength={35}
                              width={272}
                              name="PQRD_FM_WeldDepositChemistry"
                              setError={setError}
                              handleOnInput={handleOnInput}
                              TypeofCheck={isAlphanumericSpecialCharactersRestrictedChar}
                              handleChangedetailsarray={
                                handleChangedetailsarray
                              }
                              onBlur={(e) => {
                                let error = isAlphanumericSpecialCharactersRestrictedChar(
                                  e.target.value,
                                );
                                setError((prevState) => ({
                                  ...prevState,
                                  PQRD_FM_WeldDepositChemistry: error,
                                }));
                              }}
                            ></PQRFillerMetalInput>
                          ) : (
                            ""
                          )}
                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Flux AWS Specification & Classification"
                            Columndimension=""
                            status={error.PQRD_FM_FluxAWS.status}
                            message={error.PQRD_FM_FluxAWS.message}
                            type="text"
                            maxLength={!isoverlay? 24: 35}
                            width={272}
                            name="PQRD_FM_FluxAWS"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={!isoverlay? isAlphanumericAllSpecialCharactersAmpersand: isAlphanumericSpecialCharactersRestrictedChar}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericSpecialCharactersRestrictedChar(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_FM_FluxAWS: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          {isoverlay ? (
                            <PQRFillerMetalInput
                              wps_detail={detailObj}
                              ColumnHeader="Flux Nominal Composition"
                              Columndimension=""
                              status={
                                error.PQRD_FM_FluxNominalComposition.status
                              }
                              message={
                                error.PQRD_FM_FluxNominalComposition.message
                              }
                              type="text"
                              maxLength={35}
                              width={272}
                              name="PQRD_FM_FluxNominalComposition"
                              setError={setError}
                              handleOnInput={handleOnInput}
                              TypeofCheck={isAlphanumericSpecialCharactersRestrictedChar}
                              handleChangedetailsarray={
                                handleChangedetailsarray
                              }
                              onBlur={(e) => {
                                let error = isAlphanumericSpecialCharactersRestrictedChar(
                                  e.target.value,
                                );
                                setError((prevState) => ({
                                  ...prevState,
                                  PQRD_FM_FluxNominalComposition: error,
                                }));
                              }}
                            ></PQRFillerMetalInput>
                          ) : (
                            ""
                          )}
                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Flux Trade Name"
                            Columndimension=""
                            status={error.PQRD_FM_FluxTradeName.status}
                            message={error.PQRD_FM_FluxTradeName.message}
                            type="text"
                            width={272}
                            maxLength={!isoverlay? 24: 35}
                            name="PQRD_FM_FluxTradeName"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={!isoverlay? isAlphanumericAllSpecialCharactersAmpersand: isAlphanumericSpecialCharactersRestrictedChar}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericSpecialCharactersRestrictedChar(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_FM_FluxTradeName: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Flux Type"
                            Columndimension=""
                            width={272}
                            status={error.PQRD_FM_FluxType.status}
                            message={error.PQRD_FM_FluxType.message}
                            type="text"
                            maxLength={!isoverlay? 24: 35}
                            name="PQRD_FM_FluxType"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={!isoverlay? isAlphanumericAllSpecialCharactersAmpersand: isAlphanumericSpecialCharactersRestrictedChar}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericSpecialCharactersRestrictedChar(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_FM_FluxType: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Flux From Recrushed Slag"
                            Columndimension=""
                            status={error.PQRD_FM_FluxRecrushed.status}
                            message={error.PQRD_FM_FluxRecrushed.message}
                            type="text"
                            maxLength={!isoverlay? 24: 35}
                            width={272}
                            name="PQRD_FM_FluxRecrushed"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={!isoverlay? isAlphanumericAllSpecialCharactersAmpersand: isAlphanumericSpecialCharactersRestrictedChar}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericSpecialCharactersRestrictedChar(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_FM_FluxRecrushed: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Supplemental Filler Metal & Insert"
                            Columndimension=""
                            status={error.PQRD_FM_Supplement.status}
                            message={error.PQRD_FM_Supplement.message}
                            type="text"
                            maxLength={!isoverlay? 24: 35}
                            width={272}
                            name="PQRD_FM_Supplement"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={!isoverlay? isAlphanumericAllSpecialCharactersAmpersand: isAlphanumericSpecialCharactersRestrictedChar}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericSpecialCharactersRestrictedChar(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_FM_Supplement: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Filler Metal Others"
                            Columndimension=""
                            status={error.PQRD_FM_FillerMetalOthers.status}
                            message={error.PQRD_FM_FillerMetalOthers.message}
                            type="text"
                            maxLength={!isoverlay? 24: 35}
                            width={272}
                            name="PQRD_FM_FillerMetalOthers"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericSpecialCharactersRestrictedChar}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericSpecialCharactersRestrictedChar(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_FM_FillerMetalOthers: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>
                        </tbody>
                      </Table>
                    </Col>
                  </div>
                    <p className="WPS-blue-text ">Position (QW-405) </p>

                    <Col style={{ position: "relative", bottom: "8px" }}>
                      <Table
                        bordered
                        responsive="sm"
                        className="text-center same-col-widths align-middle"
                      >
                        <tbody>
                          <PQRProcessGridInput3
                            wps_detail={detailObj}
                            ColumnHeader="Position of Groove"
                            Columndimension=""
                            status={error.PQRD_Position_PositionofGroove.status}
                            message={
                              error.PQRD_Position_PositionofGroove.message
                            }
                            type="text"
                            maxLength={!isoverlay? 24: 35}
                            name="PQRD_Position_PositionofGroove"
                            handleChange={handleChange3field}
                            singleInputMode={true}
                            width={220}
                            onInput={(e) => {
                              let error = isAlphanumericWithDashSlashPlusAmpersand(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Position_PositionofGroove: error,
                              }));
                            }}
                          ></PQRProcessGridInput3>
                          <PQRProcessGridInput3
                            wps_detail={detailObj}
                            ColumnHeader="Weld Progression"
                            Columndimension=""
                            status={error.PQRD_Position_WeldProgression.status}
                            message={
                              error.PQRD_Position_WeldProgression.message
                            }
                            type="text"
                            maxLength={!isoverlay? 24: 35}
                            name="PQRD_Position_WeldProgression"
                            handleChange={handleChange3field}
                            singleInputMode={true}
                            width={220}
                            onInput={(e) => {
                              let error = isAlphanumericWithDashSlashPlusAmpersand(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Position_WeldProgression: error,
                              }));
                            }}
                          ></PQRProcessGridInput3>
                        </tbody>
                      </Table>
                    </Col>
                  <span
                    className="WPS-blue-text"
                    style={{ padding: "0px 5px" }}
                  >
                    Preheat (QW-406)
                  </span>

                  <Col
                    style={{
                      padding: "0px 5px",
                      position: "relative",
                      bottom: "8px",
                    }}
                  >
                    <Table
                      bordered
                      responsive="sm"
                      className="text-center same-col-widths align-middle"
                    >
                      <tbody>
                        <PQRFillerMetalInput
                          wps_detail={detailObj}
                          ColumnHeader="Minimum Preheat Temperature"
                          Columndimension="°C"
                          status={error.PQRD_Preheat_MinimumPreheatTemp.status}
                          message={
                            error.PQRD_Preheat_MinimumPreheatTemp.message
                          }
                          type="text"
                          maxLength={35}
                          width={182}
                          name="PQRD_Preheat_MinimumPreheatTemp"
                          handleOnInput={handleOnInput}
                          TypeofCheck={!isoverlay? isAlphanumericAllSpecialCharactersPlusMinusDegreeWithAngleBrackets: isAlphanumericSpecialCharactersRestrictedChar}
                          setError={setError}
                          handleChangedetailsarray={handleChangedetailsarray}
                          onBlur={(e) => {
                            let error = isAlphanumericAllSpecialCharactersPlusMinusDegreeWithAngleBrackets(
                              e.target.value,
                            );
                            setError((prevState) => ({
                              ...prevState,
                              PQRD_Preheat_MinimumPreheatTemp: error,
                            }));
                          }}
                        ></PQRFillerMetalInput>
                        <PQRFillerMetalInput
                          wps_detail={detailObj}
                          ColumnHeader="Maximum Interpass Temperature"
                          Columndimension="°C"
                          status={
                            error.PQRD_Preheat_MaximumInterpassTemp.status
                          }
                          message={
                            error.PQRD_Preheat_MaximumInterpassTemp.message
                          }
                          type="text"
                          maxLength={35}
                          width={182}
                          name="PQRD_Preheat_MaximumInterpassTemp"
                          handleOnInput={handleOnInput}
                          TypeofCheck={!isoverlay? isAlphanumericAllSpecialCharactersPlusMinusDegreeWithAngleBrackets: isAlphanumericSpecialCharactersRestrictedChar}
                          setError={setError}
                          handleChangedetailsarray={handleChangedetailsarray}
                          onBlur={(e) => {
                            let error = isAlphanumericAllSpecialCharactersPlusMinusDegreeWithAngleBrackets(
                              e.target.value,
                            );
                            setError((prevState) => ({
                              ...prevState,
                              PQRD_Preheat_MaximumInterpassTemp: error,
                            }));
                          }}
                        ></PQRFillerMetalInput>
                      </tbody>
                    </Table>
                  </Col>
                  <span
                    className="WPS-blue-text"
                    style={{ padding: "0px 5px" }}
                  >
                    Gas (QW-408)
                  </span>
                  <Col
                    style={{
                      padding: "0px 5px",
                      position: "relative",
                      bottom: "8px",
                    }}
                  >
                    <Table
                      bordered
                      responsive="sm"
                      className="text-center same-col-widths align-middle"
                    >
                      <tbody>
                        <PQRProcessGridInput2
                          wps_detail={detailObj}
                          mainheading="Shielding"
                          ColumnHeader="Type"
                          ColumnHeader1="Flow Rate"
                          ColumnHeader2Dimension="I/min"
                          status={
                            error.PQRD_Gas_ShieldingType.status ||
                            error.PQRD_Gas_ShieldingFlowRate.status
                          }
                          message={
                            error.PQRD_Gas_ShieldingType.message ||
                            error.PQRD_Gas_ShieldingFlowRate.message
                          }
                          type="text"
                          name="PQRD_Gas_ShieldingType"
                          name1="PQRD_Gas_ShieldingFlowRate"
                          maxLength1={18}
                          maxLength2={6}
                          width1={182}
                          thstyle2={{ width: "260px" }}
                          onInput={(e) => {
                            let error = isAlphanumericMinusPlusPercent(
                              e.target.value,
                            );
                            setError((prevState) => ({
                              ...prevState,
                              PQRD_Gas_ShieldingType: error,
                            }));
                          }}
                          onInput1={(e) => {
                            let error = isAlphanumericMinusPlusPercent(
                              e.target.value,
                            );
                            setError((prevState) => ({
                              ...prevState,
                              PQRD_Gas_ShieldingFlowRate: error,
                            }));
                          }}
                          onBlur1={(e) => {
                            let error = isAlphanumericMinusPlusPercent(
                              e.target.value,
                            );
                            setError((prevState) => ({
                              ...prevState,
                              PQRD_Gas_ShieldingFlowRate: error,
                            }));
                          }}
                          onBlur={(e) => {
                            let error = isAlphanumericMinusPlusPercent(
                              e.target.value,
                            );
                            setError((prevState) => ({
                              ...prevState,
                              PQRD_Gas_ShieldingType: error,
                            }));
                          }}
                          handleChangedetailsarray={handleChangedetailsarray}
                        ></PQRProcessGridInput2>
                        {isoverlay ? (
                          ""
                        ) : (
                          <>
                            <PQRProcessGridInput2
                              wps_detail={detailObj}
                              mainheading="Backing"
                              ColumnHeader="Type"
                              ColumnHeader1="Flow Rate"
                              ColumnHeader2Dimension="I/min"
                              thstyle2={{ width: "260px" }}
                              status={
                                error.PQRD_Gas_BackingType.status ||
                                error.PQRD_Gas_BackingFlowRate.status
                              }
                              message={
                                error.PQRD_Gas_BackingType.message ||
                                error.PQRD_Gas_BackingFlowRate.message
                              }
                              type="text"
                              width1={182}
                              name="PQRD_Gas_BackingType"
                              name1="PQRD_Gas_BackingFlowRate"
                              maxLength1={18}
                              maxLength2={6}
                              onInput={(e) => {
                                let error = isAlphanumericMinusPlusPercent(
                                  e.target.value,
                                );
                                setError((prevState) => ({
                                  ...prevState,
                                  PQRD_Gas_BackingType: error,
                                }));
                              }}
                              onBlur={(e) => {
                                let error = isAlphanumericMinusPlusPercent(
                                  e.target.value,
                                );
                                setError((prevState) => ({
                                  ...prevState,
                                  PQRD_Gas_BackingType: error,
                                }));
                              }}
                              onInput1={(e) => {
                                let error = isAlphanumericMinusPlusPercent(
                                  e.target.value,
                                );
                                setError((prevState) => ({
                                  ...prevState,
                                  PQRD_Gas_BackingFlowRate: error,
                                }));
                              }}
                              onBlur1={(e) => {
                                let error = isAlphanumericMinusPlusPercent(
                                  e.target.value,
                                );
                                setError((prevState) => ({
                                  ...prevState,
                                  PQRD_Gas_BackingFlowRate: error,
                                }));
                              }}
                              handleChangedetailsarray={
                                handleChangedetailsarray
                              }
                            ></PQRProcessGridInput2>
                            <PQRProcessGridInput2
                              wps_detail={detailObj}
                              mainheading="Trailing"
                              ColumnHeader="Type"
                              ColumnHeader1="Flow Rate"
                              ColumnHeader2Dimension="I/min"
                              width1={182}
                              thstyle2={{ width: "260px" }}
                              status={
                                error.PQRD_Gas_TrailingType.status ||
                                error.PQRD_Gas_TrailingFlowRate.status
                              }
                              message={
                                error.PQRD_Gas_TrailingType.message ||
                                error.PQRD_Gas_TrailingFlowRate.message
                              }
                              type="text"
                              name="PQRD_Gas_TrailingType"
                              name1="PQRD_Gas_TrailingFlowRate"
                              maxLength1={18}
                              maxLength2={6}
                              onInput={(e) => {
                                let error = isAlphanumericMinusPlusPercent(
                                  e.target.value,
                                );
                                setError((prevState) => ({
                                  ...prevState,
                                  PQRD_Gas_TrailingType: error,
                                }));
                              }}
                              onBlur={(e) => {
                                let error = isAlphanumericMinusPlusPercent(
                                  e.target.value,
                                );
                                setError((prevState) => ({
                                  ...prevState,
                                  PQRD_Gas_TrailingType: error,
                                }));
                              }}
                              onInput1={(e) => {
                                let error = isAlphanumericMinusPlusPercent(
                                  e.target.value,
                                );
                                setError((prevState) => ({
                                  ...prevState,
                                  PQRD_Gas_TrailingFlowRate: error,
                                }));
                              }}
                              onBlur1={(e) => {
                                let error = isAlphanumericMinusPlusPercent(
                                  e.target.value,
                                );
                                setError((prevState) => ({
                                  ...prevState,
                                  PQRD_Gas_TrailingFlowRate: error,
                                }));
                              }}
                              handleChangedetailsarray={
                                handleChangedetailsarray
                              }
                            ></PQRProcessGridInput2>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                  <div className="scrollpqr">
                    <p
                      className="WPS-blue-text "
                      style={{ padding: "0px 5px" }}
                    >
                      Electrical (QW-409){" "}
                    </p>
                    <Col
                      style={{
                        padding: "0px 5px",
                        position: "relative",
                        bottom: "8px",
                      }}
                    >
                      <Table
                        bordered
                        responsive="sm"
                        className="text-center same-col-widths align-middle"
                      >
                        <tbody>
                          <PQRProcessGridInput3
                            detailObj={detailObj}
                            wps_detail={detailObj}
                            ColumnHeader={!isoverlay ? "Filler Metal Size(Ø)" : "Filler Metal Size"}
                            Columndimension="mm"
                            status={
                              error.PQRD_Electrical_FillerMetalSize.status
                            }
                            message={
                              error.PQRD_Electrical_FillerMetalSize.message
                            }
                            type="text"
                            maxLength={12}
                            name="PQRD_Electrical_FillerMetalSize"
                            handleChange={handleChange3field}
                            onInput={(e) => {
                              let error = isAlphanumericMinusPlusPercentDiameter(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Electrical_FillerMetalSize: error,
                              }));
                            }}
                          ></PQRProcessGridInput3>
                          <PQRProcessGridInput3
                            wps_detail={detailObj}
                            ColumnHeader="Amperes"
                            Columndimension="Amps"
                            status={error.PQRD_Electrical_Amperes.status}
                            message={error.PQRD_Electrical_Amperes.message}
                            type="text"
                            maxLength={!isoverlay? 7: 12}
                            name="PQRD_Electrical_Amperes"
                            handleChange={handleChange3field}
                            onInput={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Electrical_Amperes: error,
                              }));
                            }}
                          ></PQRProcessGridInput3>

                          <PQRProcessGridInput3
                            wps_detail={detailObj}
                            ColumnHeader="Voltage"
                            Columndimension="Volts"
                            status={error.PQRD_Electrical_Volts.status}
                            message={error.PQRD_Electrical_Volts.message}
                            type="text"
                            maxLength={!isoverlay? 7: 12}
                            name="PQRD_Electrical_Volts"
                            handleChange={handleChange3field}
                            onInput={(e) => {
                              let error =isAlphanumericMinusPlusPercent (
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Electrical_Volts: error,
                              }));
                            }}
                          ></PQRProcessGridInput3>

                          <PQRProcessGridInput3
                            wps_detail={detailObj}
                            ColumnHeader="Travel Speed"
                            Columndimension="mm/min"
                            status={error.PQRD_Electrical_TravelSpeed.status}
                            message={error.PQRD_Electrical_TravelSpeed.message}
                            type="text"
                            maxLength={!isoverlay? 7: 12}
                            name="PQRD_Electrical_TravelSpeed"
                            handleChange={handleChange3field}
                            onInput={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Electrical_TravelSpeed: error,
                              }));
                            }}
                          ></PQRProcessGridInput3>
                          <PQRProcessGridInput3
                            wps_detail={detailObj}
                            ColumnHeader="Minimum bead Length (SMAW)"
                            Columndimension="mm"
                            status={error.PQRD_Electrical_minBeadLength.status}
                            message={
                              error.PQRD_Electrical_minBeadLength.message
                            }
                            type="text"
                            maxLength={!isoverlay? 7: 12}
                            name="PQRD_Electrical_minBeadLength"
                            handleChange={handleChange3field}
                            onInput={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Electrical_minBeadLength: error,
                              }));
                            }}
                          ></PQRProcessGridInput3>
                          <PQRProcessGridInput3
                            wps_detail={detailObj}
                            ColumnHeader="Arc Transfer Mode (FCAW/GMAW)"
                            status={
                              error.PQRD_Electrical_ArcTransferMode.status
                            }
                            message={
                              error.PQRD_Electrical_ArcTransferMode.message
                            }
                            type="text"
                            maxLength={!isoverlay? 7: 12}
                            name="PQRD_Electrical_ArcTransferMode"
                            handleChange={handleChange3field}
                            onInput={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Electrical_ArcTransferMode: error,
                              }));
                            }}
                          ></PQRProcessGridInput3>

                          <PQRProcessGridInput3
                            wps_detail={detailObj}
                            ColumnHeader="Maximum Heat Input"
                            Columndimension="kj/mm"
                            status={error.PQRD_Electrical_MaxHeatInput.status}
                            message={error.PQRD_Electrical_MaxHeatInput.message}
                            type="text"
                            maxLength={!isoverlay? 7: 12}
                            name="PQRD_Electrical_MaxHeatInput"
                            handleChange={handleChange3field}
                            onInput={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Electrical_MaxHeatInput: error,
                              }));
                            }}
                          ></PQRProcessGridInput3>

                          <PQRProcessGridInput3
                            wps_detail={detailObj}
                            ColumnHeader="Tungsten Type & Size"
                            Columndimension=""
                            status={error.PQRD_Electrical_TungstenType.status}
                            message={error.PQRD_Electrical_TungstenType.message}
                            type="text"
                            maxLength={35}
                            singleInputMode={true}
                            name="PQRD_Electrical_TungstenType"
                            handleChange={handleChange3field}
                            onInput={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Electrical_TungstenType: error,
                              }));
                            }}
                          ></PQRProcessGridInput3>

                          <PQRProcessGridInput3
                            wps_detail={detailObj}
                            ColumnHeader="Current/Polarity"
                            Columndimension=""
                            status={
                              error.PQRD_Electrical_CurrentPolarity.status
                            }
                            message={
                              error.PQRD_Electrical_CurrentPolarity.message
                            }
                             singleInputMode={true}
                            type="text"
                            maxLength={24}
                            name="PQRD_Electrical_CurrentPolarity"
                            handleChange={handleChange3field}
                            onInput={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Electrical_CurrentPolarity: error,
                              }));
                            }}
                          ></PQRProcessGridInput3>

                          <PQRProcessGridInput3
                            wps_detail={detailObj}
                            ColumnHeader="DC Pulsating Current"
                            Columndimension=""
                            status={
                              error.PQRD_Electrical_DCPulsatingCurrent.status
                            }
                            message={
                              error.PQRD_Electrical_DCPulsatingCurrent.message
                            }
                            type="text"
                            maxLength={!isoverlay? 7: 12}
                            name="PQRD_Electrical_DCPulsatingCurrent"
                            handleChange={handleChange3field}
                            onInput={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Electrical_DCPulsatingCurrent: error,
                              }));
                            }}
                          ></PQRProcessGridInput3>
                          {!isoverlay && (
                            <PQRFillerMetalInput
                              wps_detail={detailObj}
                              ColumnHeader="Electrical Others"
                              Columndimension=""
                              status={error.PQRD_Electrical_Others.status}
                              message={error.PQRD_Electrical_Others.message}
                              type="text"
                              maxLength={24}
                              width={272}
                              name="PQRD_Electrical_Others"
                              setError={setError}
                              handleOnInput={handleOnInput}
                              TypeofCheck={isAlphanumericMinusPlusPercent}
                              handleChangedetailsarray={handleChangedetailsarray}
                            ></PQRFillerMetalInput>
                          )}
                          {isoverlay ? (
                            <PQRProcessGridInput3
                              wps_detail={detailObj}
                              ColumnHeader="Wire Feed Type"
                              Columndimension=""
                              status={error.PQRD_Electrical_WireFeedType.status}
                              message={
                                error.PQRD_Electrical_WireFeedType.message
                              }
                              type="text"
                              maxLength={12}
                              name="PQRD_Electrical_WireFeedType"
                              handleChange={handleChange3field}
                              onInput={(e) => {
                                let error = isAlphanumericMinusPlusPercent(
                                  e.target.value,
                                );
                                setError((prevState) => ({
                                  ...prevState,
                                  PQRD_Electrical_WireFeedType: error,
                                }));
                              }}
                            ></PQRProcessGridInput3>
                          ) : (
                            ""
                          )}

                          {isoverlay ? (
                            <PQRProcessGridInput3
                              wps_detail={detailObj}
                              ColumnHeader="Wire Feed Speed"
                              Columndimension=""
                              status={
                                error.PQRD_Electrical_WireFeedSpeed.status
                              }
                              message={
                                error.PQRD_Electrical_WireFeedSpeed.message
                              }
                              type="text"
                              maxLength={12}
                              name="PQRD_Electrical_WireFeedSpeed"
                              handleChange={handleChange3field}
                              onInput={(e) => {
                                let error = isAlphanumericMinusPlusPercent(
                                  e.target.value,
                                );
                                setError((prevState) => ({
                                  ...prevState,
                                  PQRD_Electrical_WireFeedSpeed: error,
                                }));
                              }}
                            ></PQRProcessGridInput3>
                          ) : (
                            ""
                          )}
                        </tbody>
                      </Table>
                    </Col>{" "}
                  </div>
                  <span>
                    {" "}
                    <p className="WPS-blue-text ">Technique (QW-410) </p>
                  </span>

                  {isoverlay ? (
                    <Col style={{ position: "relative", bottom: "8px" }}>
                      <Table
                        bordered
                        responsive="sm"
                        className="text-center same-col-widths align-middle"
                      >
                        <tbody>
                          <PQRFillerMetalInput
                            detailObj={detailObj}
                            wps_detail={detailObj}
                            ColumnHeader="Oscillation"
                            Columndimension=""
                            status={error.PQRD_Technique_Oscillation.status}
                            message={error.PQRD_Technique_Oscillation.message}
                            type="text"
                            maxLength={35}
                            width={200}
                            name="PQRD_Technique_Oscillation"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="No. of electrodes on same Puddle"
                            Columndimension=""
                            status={
                              error.PQRD_Technique_ElectrodesSamePuddle.status
                            }
                            message={
                              error.PQRD_Technique_ElectrodesSamePuddle.message
                            }
                            type="text"
                            maxLength={35}
                            width={200}
                            name="PQRD_Technique_ElectrodesSamePuddle"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Multiple or Single Layer"
                            Columndimension=""
                            status={
                              error.PQRD_Technique_Multiple_SingleLayer.status
                            }
                            message={
                              error.PQRD_Technique_Multiple_SingleLayer.message
                            }
                            type="text"
                            maxLength={35}
                            width={200}
                            name="PQRD_Technique_Multiple_SingleLayer"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Supplimental Device"
                            Columndimension=""
                            status={
                              error.PQRD_Technique_SupplimentalDevice.status
                            }
                            message={
                              error.PQRD_Technique_SupplimentalDevice.message
                            }
                            type="text"
                            maxLength={35}
                            width={200}
                            name="PQRD_Technique_SupplimentalDevice"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Initial/Interpass Cleaning"
                            Columndimension=""
                            status={
                              error.PQRD_Technique_InitialInterpassCleaning
                                .status
                            }
                            message={
                              error.PQRD_Technique_InitialInterpassCleaning
                                .message
                            }
                            type="text"
                            maxLength={35}
                            width={200}
                            name="PQRD_Technique_InitialInterpassCleaning"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Overlaping"
                            Columndimension=""
                            status={error.PQRD_Technique_Overlaping.status}
                            message={error.PQRD_Technique_Overlaping.message}
                            type="text"
                            maxLength={35}
                            width={200}
                            name="PQRD_Technique_Overlaping"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="C.T.W.D."
                            Columndimension="mm"
                            status={error.PQRD_Technique_CTWD.status}
                            message={error.PQRD_Technique_CTWD.message}
                            type="text"
                            maxLength={35}
                            width={200}
                            name="PQRD_Technique_CTWD"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                          ></PQRFillerMetalInput>
                        </tbody>
                      </Table>
                    </Col>
                  ) : (
                    <Col style={{ position: "relative", bottom: "8px" }}>
                      <Table
                        bordered
                        responsive="sm"
                        className="text-center same-col-widths align-middle"
                      >
                        <tbody>
                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="String Or Weave"
                            Columndimension=""
                            status={error.PQRD_Technique_StringOrWeave.status}
                            message={error.PQRD_Technique_StringOrWeave.message}
                            type="text"
                            maxLength={25}
                            width={200}
                            name="PQRD_Technique_StringOrWeave"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Technique_StringOrWeave: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Orifice Gas/Cup Size"
                            Columndimension=""
                            status={
                              error.PQRD_Technique_Orifice_GasCupSize.status
                            }
                            message={
                              error.PQRD_Technique_Orifice_GasCupSize.message
                            }
                            type="text"
                            maxLength={25}
                            width={200}
                            name="PQRD_Technique_Orifice_GasCupSize"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Technique_Orifice_GasCupSize: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="C.T.W.D."
                            Columndimension="mm"
                            status={error.PQRD_Technique_CTWD.status}
                            message={error.PQRD_Technique_CTWD.message}
                            type="text"
                            maxLength={25}
                            width={200}
                            name="PQRD_Technique_CTWD"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Technique_CTWD: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Oscillation"
                            Columndimension=""
                            status={error.PQRD_Technique_Oscillation.status}
                            message={error.PQRD_Technique_Oscillation.message}
                            type="text"
                            maxLength={25}
                            width={200}
                            name="PQRD_Technique_Oscillation"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Technique_Oscillation: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Multi/Single Electrode"
                            Columndimension=""
                            status={
                              error.PQRD_Technique_Multi_SingleElectrode.status
                            }
                            message={
                              error.PQRD_Technique_Multi_SingleElectrode.message
                            }
                            type="text"
                            maxLength={25}
                            width={200}
                            name="PQRD_Technique_Multi_SingleElectrode"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Technique_Multi_SingleElectrode: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Electrode Angle"
                            Columndimension="deg."
                            status={error.PQRD_Technique_ElectrodeAngle.status}
                            message={
                              error.PQRD_Technique_ElectrodeAngle.message
                            }
                            type="text"
                            maxLength={25}
                            width={200}
                            name="PQRD_Technique_ElectrodeAngle"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Technique_ElectrodeAngle: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Multi/Single Pass Per Side"
                            Columndimension=""
                            status={
                              error.PQRD_Technique_SinglePassPerSide.status
                            }
                            message={
                              error.PQRD_Technique_SinglePassPerSide.message
                            }
                            type="text"
                            maxLength={25}
                            width={200}
                            name="PQRD_Technique_SinglePassPerSide"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Technique_SinglePassPerSide: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Multiple or Single Layer"
                            Columndimension=""
                            status={
                              error.PQRD_Technique_Multiple_SingleLayer.status
                            }
                            message={
                              error.PQRD_Technique_Multiple_SingleLayer.message
                            }
                            type="text"
                            maxLength={25}
                            width={200}
                            name="PQRD_Technique_Multiple_SingleLayer"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Technique_Multiple_SingleLayer: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Peening"
                            Columndimension=""
                            status={error.PQRD_Technique_Peening.status}
                            message={error.PQRD_Technique_Peening.message}
                            type="text"
                            maxLength={25}
                            width={200}
                            name="PQRD_Technique_Peening"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Technique_Peening: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Initial/Interpass Cleaning"
                            Columndimension=""
                            status={
                              error.PQRD_Technique_InitialInterpassCleaning
                                .status
                            }
                            message={
                              error.PQRD_Technique_InitialInterpassCleaning
                                .message
                            }
                            type="text"
                            maxLength={25}
                            width={200}
                            name="PQRD_Technique_InitialInterpassCleaning"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Technique_InitialInterpassCleaning: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>

                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Back Gauging Method"
                            Columndimension=""
                            status={
                              error.PQRD_Technique_BackGaugingMethod.status
                            }
                            message={
                              error.PQRD_Technique_BackGaugingMethod.message
                            }
                            type="text"
                            maxLength={25}
                            width={200}
                            name="PQRD_Technique_BackGaugingMethod"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Technique_BackGaugingMethod: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>
                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Technique Others"
                            Columndimension=""
                            status={error.PQRD_Technique_Technique_Other.status}
                            message={
                              error.PQRD_Technique_Technique_Other.message
                            }
                            type="text"
                            maxLength={25}
                            width={200}
                            name="PQRD_Technique_Technique_Other"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Technique_Technique_Other: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>
                          <PQRFillerMetalInput
                            wps_detail={detailObj}
                            ColumnHeader="Groove Preparation"
                            Columndimension=""
                            status={
                              error.PQRD_Technique_GroovePreparation.status
                            }
                            message={
                              error.PQRD_Technique_GroovePreparation.message
                            }
                            type="text"
                            maxLength={25}
                            width={200}
                            name="PQRD_Technique_GroovePreparation"
                            setError={setError}
                            handleOnInput={handleOnInput}
                            TypeofCheck={isAlphanumericMinusPlusPercent}
                            handleChangedetailsarray={handleChangedetailsarray}
                            onBlur={(e) => {
                              let error = isAlphanumericMinusPlusPercent(
                                e.target.value,
                              );
                              setError((prevState) => ({
                                ...prevState,
                                PQRD_Technique_GroovePreparation: error,
                              }));
                            }}
                          ></PQRFillerMetalInput>
                        </tbody>
                      </Table>
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Row>
        </div>
      </Row>
    );
  },
);

export default React.memo(PQRPage1);
